import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

export const useLogClickRequestVerification = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(() => {
    logAnalyticsEvent({
      name: 'CLICK_REQUEST_VERIFICATION',
      channel: ['firebase', 'amplitude', 'ablylog'],
    });
  }, [logAnalyticsEvent]);
};
